const accordionBtns = document.querySelectorAll(".Mob_Menu");
accordionBtns.forEach((accordion) => {
  let firstClick = true; // Flag to track the first click
  accordion.onclick = function (e) {
    event.preventDefault()
    this.classList.toggle("is-open");
    let content = this.nextElementSibling;
    let addHeight = 0;
    if (firstClick) {
      addHeight = 35;
      firstClick = false;
    } else {
      addHeight = 0;
    }
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + addHeight + "px";
    }
  };
});

let eventAddedClass = 'js-event-added';
document.querySelectorAll('.list_build_a_bundle').forEach(function(ele){
  if(ele.classList.contains(eventAddedClass)) return;
  ele.classList.add(eventAddedClass);
  ele.addEventListener('click',function(e){
    document.querySelector('.Custom_Model_Main').classList.add('Model_Open');
    document.querySelector('body').classList.add('list_build_a_bundle');
  });
});
if(document.querySelector(".Close_Button")){
  if(!document.querySelector(".Close_Button").classList.contains(eventAddedClass)){
    document.querySelector(".Close_Button").classList.add(eventAddedClass);
    document.querySelector(".Close_Button").addEventListener('click',function(){
      document.querySelector('.Custom_Model_Main').classList.remove('Model_Open');
      document.querySelector('body').classList.remove('list_build_a_bundle');
    });
  }
}
// window.bundleSlider = function(){
// if(document.querySelector('.main-carousel-bundle')){
//   let bundleElem = document.querySelector('.main-carousel-bundle');
//   let bundleFlkty = new Flickity( bundleElem, {
//     cellAlign: 'left',
//     contain: true,
//     groupCells: 2,
//     cellSelector: ".bundle-item",
//     pageDots: false,
//     adaptiveHeight: false,
//     prevNextButtons: true,
//     draggable: true,
//     imagesLoaded: true,
//     wrapAround: true,
//     arrowShape: { 
//       x0: 10,
//       x1: 60, y1: 50,
//       x2: 65, y2: 45,
//       x3: 20
//     }
//    }); 
//   window.bundleFlkty = bundleFlkty;

//   var previousButton = bundleElem.querySelector('.bundle-carousel__pagination-arrow--prev');
//   if(previousButton){
//     previousButton.addEventListener('click', function() {
//       bundleFlkty.previous();
//     });
//   }
//   var nextButton = bundleElem.querySelector('.bundle-carousel__pagination-arrow--next');
//   if(nextButton){
//     nextButton.addEventListener('click', function() {
//       bundleFlkty.next();
//     });
//   }
//  }  
// }


// window.handleFlickityBreakpointsForBundle = function(){
//   if(document.querySelectorAll(".main-carousel-bundle").length > 0){

//     function checkWidths(productCount){
//       if(document.querySelectorAll(".main-carousel-bundle .bundle-item").length > productCount){
//         window.bundleSlider();
//       }
//       else{
//         if(typeof window.bundleFlkty !== "undefined"){
//           window.bundleFlkty.destroy();
//         }
//       }
//     }
    
//     const screenWidth = window.innerWidth;
//     if (screenWidth <= 375) {
//       checkWidths(2)
//     } 
//     else if (screenWidth <= 576) {
//       checkWidths(3)
//     }
//     else if (screenWidth <= 699) {
//       checkWidths(4)
//     }
//     else if (screenWidth <= 860) {
//       checkWidths(5)
//     }
//     else if (screenWidth <= 1024) {
//       checkWidths(6)
//     }
//     else if (screenWidth <= 1200) {
//       checkWidths(7)
//     }
//     else {
//       checkWidths(8)
//     }
//   }
//   else{
//     window.bundleSlider();
//   }
// }
// window.handleFlickityBreakpointsForBundle();

// window.addEventListener("resize", function(){
//   window.handleFlickityBreakpointsForBundle();
// });

window.matchHeight = function(selector) {
  const elements = document.querySelectorAll(selector);
  function setEqualHeight() {
    let maxHeight = 0;
    elements.forEach(element => {
      element.style.height = 'auto';
      const elementHeight = element.clientHeight;
      if (elementHeight > maxHeight) {
        maxHeight = elementHeight;
      }
    });

    elements.forEach(element => {
      element.style.height = `${maxHeight}px`;
    });
  }
  setEqualHeight();
  window.addEventListener('resize', setEqualHeight);
}
window.matchHeight('.bundle-item .product-title');
window.matchHeight('.bundle-item .wrapper-vendor');
window.matchHeight('.bundle-item .price-box');

window.craftTestimonial = function() {
  let sliders = document.querySelectorAll('.component__craft-tips-list');
  if (window.innerWidth <= 749) {
    sliders.forEach(function(elem) {
      let flkty = new Flickity(elem, {
        cellAlign: 'left',
        pageDots: false,
        contain: true,
        groupCells: true,
        prevNextButtons: true,
        draggable: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });
    });
  }
}
window.craftTestimonial();

window.announcement = function() {
  let sliders = document.querySelectorAll('.top_banner_annoucement');
  sliders.forEach(function(elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      pageDots: false,
      autoPlay: true,
      contain: true,
      groupCells: true,
      draggable: true,
      wrapAround: true,
      prevNextButtons: false
    });
    $('.top_banner_annoucement .promotion_text').css("opacity","1");
    $('.top_banner_annoucement .promotion_text').css('height', '');
  });
}
window.announcement();

window.relatedProducts = function() {
  let sliderContainers = document.querySelectorAll('.related__product--grid');
  // Check if the screen width is greater than 989 pixels
  if (window.innerWidth > 989) {
    // Loop through all slider containers and destroy Flickity instances
    sliderContainers.forEach(container => {
      let flickityInstance = Flickity.data(container);
      if (flickityInstance) {
        flickityInstance.destroy();
      }
    });
  } else {
    // Initialize Flickity sliders
    sliderContainers.forEach(container => {
      new Flickity(container, {
        wrapAround: true,
        adaptiveHeight: false,
        pageDots: false,
        prevNextButtons: true,
        cellAlign: 'left',
        prevNextButtons: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });
    });
  }
};

// Call the function on page load
window.relatedProducts();
// Add a resize event listener to reevaluate the sliders on window resize
window.addEventListener('resize', window.relatedProducts);

window.filterImageButtons = function(){
  let elem = document.querySelector('.filter__image--buttons');
if(elem && document.querySelectorAll('.filter__image--items').lenght > 0){
  if(elem.classList.contains('flickity-enabled')) return;
  let flkty = new Flickity( elem, {
    cellAlign: 'center',
    contain: true,
    groupCells: 2,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    autoPlay: true,
    autoPlay: 3000,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          cellAlign: 'left'
        }
      }
    ]
  }); 
 }  
}
window.filterImageButtons();

window.sliderDesktop = function(){
  let sliderContainers = document.querySelectorAll('.Slider_Desktop');
  sliderContainers.forEach(container => {
    new Flickity(container, {
      wrapAround: true,
      adaptiveHeight: false,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'left',
      prevNextButtons: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      },
      on: {
        ready: function(e) {
          setTimeout(function name(params) {
            if(container.querySelector('grid-alignment-wrapper')) container.querySelector('grid-alignment-wrapper').init();
          },1000)
        }
      }
    });
  });
}
window.sliderDesktop();

window.gridSlider = function() {
  let isGridSlider = document.querySelectorAll('.grid__slider');
  isGridSlider.forEach(function(elem) {
    let flkty = new Flickity(elem, {
      cellAlign: `${elem.getAttribute('data-align')}`,
      pageDots: false,
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });
  });
}
window.gridSlider();

window.gridColumnSlider = function() {
  let isGridColumnSlider = document.querySelectorAll('.gridcolumn__slider');
  isGridColumnSlider.forEach(function(elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      pageDots: false,
      groupCells: 1,
      contain: true,
      prevNextButtons: true,
      draggable: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });
  });
}
var gridSlider = document.querySelectorAll('.gridcolumn__slider-slide');
if(window.innerWidth > 1650 && gridSlider.length > 6 ) {
  window.gridColumnSlider();
} else if(window.innerWidth < 1651 && window.innerWidth > 850 && gridSlider.length > 3) {
  window.gridColumnSlider();
} else {
  if(window.innerWidth < 851) {
    window.gridColumnSlider();
  }
}


window.imageCarousel = function() {
  let isGridColumnSlider = document.querySelectorAll('.image__carousel');
  isGridColumnSlider.forEach(function(elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      pageDots: false,
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });
  });
}
window.imageCarousel();

window.imageCarouselMobile = function() {
  let isGridColumnSlider = document.querySelectorAll('.mobile_image__carousel');
  isGridColumnSlider.forEach(function(elem) {
    if(!elem.classList.contains('.image__carousel')){
      let flkty = new Flickity(elem, {
        cellAlign: 'left',
        pageDots: false,
        groupCells: true,
        contain: true,
        prevNextButtons: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });
    }
    
  });
}

if (window.innerWidth < 1280) {
  window.imageCarouselMobile();
}

window.gridPotraitSlider = function() {
  let isGridPotraitSlider = document.querySelectorAll('.gridpotrait__slider');
  isGridPotraitSlider.forEach(function(elem) {
    let flkty = new Flickity(elem, {
      watchCSS: true,
      cellAlign: 'left',
      pageDots: false,
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });
  });
}
window.gridPotraitSlider();

window.collectionListSlider = function(){
  let collectionList = document.querySelectorAll('.Collection_List_Slider');
  collectionList.forEach(container => {
    new Flickity(container, {
      wrapAround: true,
      watchCSS: true,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'left',
      arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
    });
  });
}
window.collectionListSlider();

window.customCollectionListSlider = function(){
  let collectionList = document.querySelectorAll('.Custom_Collection_List_Slider');
  collectionList.forEach(container => {
    new Flickity(container, {
      wrapAround: false,
      watchCSS: true,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'left',
      freeScroll: true,
      groupCells: true,
      contain: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });
  });
}

if (window.innerWidth < 1280) {
  window.customCollectionListSlider();
} else {
  // if (document.querySelectorAll('.collection-list__item').length > 3) {
  //   window.customCollectionListSlider();
  // }
}

let videoElements = document.querySelectorAll('.hero-video');
if (videoElements) {
    videoElements.forEach(function (videoElement) {
      videoElement.play().catch(error => {
          console.log('Autoplay prevented:', error);
      });
    })
}

window.mobileSlider = function(){
  let mobileSlider = document.querySelectorAll('.Slider_Mobile');
  mobileSlider.forEach(container => {
    new Flickity(container, {
      wrapAround: true,
      watchCSS: true,
      pageDots: false,
      prevNextButtons: true,
      cellAlign: 'left',
      arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
    });
  });
}
window.mobileSlider();

let blogSlider = document.querySelectorAll('.Blog_List_Slider');
blogSlider.forEach(container => {
  new Flickity(container, {
    wrapAround: true,
    pageDots: false,
    watchCSS: true,
    prevNextButtons: true,
    cellAlign: 'left',
    prevNextButtons: true,
    arrowShape: { 
    x0: 10,
    x1: 60, y1: 50,
    x2: 65, y2: 45,
    x3: 20
  }
  });
});

if(document.querySelector('#showtime')){
  document.querySelector('#showtime').addEventListener('click', function(){
    let FilterSelector = document.getElementById('shopify-section-sidebar-filter');
    if (FilterSelector.style.display === 'none') {
      FilterSelector.style.display = 'block';
      document.querySelector('#shopify-section-collection-template-skin-1').classList.add('show-bundle-filter');
      document.querySelector('#showtime').innerText = 'Hide Filters'
    } else {
      FilterSelector.style.display = 'none';
      document.querySelector('#shopify-section-collection-template-skin-1').classList.remove('show-bundle-filter');
      document.querySelector('#showtime').innerText = 'Show Filters'
    }
  });
}

//FreeShipping AnnouncementBar
window.GetCart = function getcart(){
   $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'json',
    success: function(cart){
      let items = cart.items;
      let itemCount = 0;
      for(var i=0; i < items.length; i++){
        let property = items[i].properties;
      }
      FreeShippingMessage(cart);
      window.updateShippingBar(cart);
    },
    error: function(err){
    console.log('error',err);
    }
  })
}

function FreeShippingMessage (cart) {
  let freeshipPrice = parseInt(window.free_shipping_price);
  let cartTotalPrice =  parseInt(cart.total_price) / 100;
  let freeshipBar = Math.round((cartTotalPrice * 100)/freeshipPrice) ;
  let target_amount = $('.top-message').data('target');
  let wholesaleTargetAmount = $('.top-message').data('wholesale-target');
  let wholeSaleTag = $('.top-message').data('wholesale');
  let target = parseInt(target_amount/100);

  let wholeSaleTarget = parseInt(wholesaleTargetAmount/100);
    if(wholeSaleTag == true){
      $('.top-message').text("ALL WHOLESALE ORDERS REQUIRE A $250.00 MINIMUM to checkout");
      if(cart.item_count <= 0){
        $('.wholesale-order-required-subtext').html("All wholesale orders require a $250.00 minimum. Shipping is free on all wholesale orders.")
        }else{
          if(wholeSaleTarget <= cartTotalPrice ){
            $('.wholesale-order-required-text').addClass('wholesale-order-qualified')
            $('.wholesale-order-required-subtext').html("Your wholesale order minimum has been met you can continue shopping or checkout now. <span>Shipping is free on all wholesale orders.</span>")
            $('.btn-checkout').removeAttr('disabled');
          }else{
            let remaining_amount = wholeSaleTarget - cartTotalPrice;
            let round_amount = remaining_amount.toFixed(2);
            $('.wholesale-order-required-text').removeClass('wholesale-order-qualified')
            $('.wholesale-order-required-subtext').html("All wholesale orders require a $250.00 minimum. Shipping is free on all wholesale orders.");
            $('.btn-checkout').attr('disabled','disabled');
          }
        }
    }else{
        if(cart.item_count <= 0){
          $('.top-message').text("Orders $"+ target +"+ Ship Free in Continental USA")
        }else{
          if(target <= cartTotalPrice ){
            $('.top-message').text("Your order qualifies for Free Shipping!");
            $('.js-accordion-free-shipping').text('Free');
            $('.js-accordion-free-shipping').addClass('Green_Text');
            $('.js-sub-accord-text').html("Your order qualifies for Free <a href='/pages/shipping'>Shipping!</a>");
          }else{
            if(window.cartThresholdShipping.threshold){
              target = window.cartThresholdShipping.threshold / 100;
            }
            let remaining_amount = target - cartTotalPrice;
            let round_amount = remaining_amount.toFixed(2);
            $('.top-message').text("Add $"+ round_amount +" for Free Shipping");
            $('.js-accordion-free-shipping').text('Get Free Shipping');
            $('.js-accordion-free-shipping').removeClass('Green_Text');
            $('.js-sub-accord-text').html("Add $"+ round_amount +" more for Free <a href='/pages/shipping'>Shipping</a>");
          } 
        }
   }
}

window.FreeShippingMessage = FreeShippingMessage;

window.GetCart();
//End FreeShipping AnnouncementBar Function
window.ShowMessageOnPdp = function ShowMessageOnPdp(){
  if(document.querySelectorAll('.js-bundle-message').length){
    document.querySelectorAll('.js-bundle-message').forEach(function(button){
      button.addEventListener('click',function(ele){
        button.classList.toggle('open');
        // document.querySelectorAll('.variant__description--item').forEach(function(ele){
        //     ele.classList.remove;('active')
        // })
        // button.nextElementSibling.toggleAttribute('hidden');
        button.nextElementSibling.classList.toggle('hidden');
         // ele.target.parentElement.classList.add('active') 
      })  
    })
  }
}
window.ShowMessageOnPdp();

customElements.define('media-gallery-custom-slider',class mediaGalleryCustomSlider extends HTMLElement {
  constructor(params) {
    super();
    this.mainSliderEle = this.querySelector('.js-Gallery_Slider');
    this.thumbnailSliderEle = this.querySelector('.js-Thumbnail_Custom_Slider');
    if(!this.mainSliderEle || !this.thumbnailSliderEle) return;
    var _this = this;
    setTimeout(function(){
      _this._manSlider();
      _this._thumbnailSlider();
      _this._showImages();
    },500)
  }

  _manSlider() {
    const showMobileDots = JSON.parse(this.mainSliderEle.dataset.showMobileDots);

    const flkty = new Flickity(this.mainSliderEle, {
      wrapAround: false,
      pageDots: showMobileDots,
      draggable: window.matchMedia('(max-width: 749px)').matches,
      prevNextButtons: true,
      resize: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });

    const progressBar = document.querySelector('.slider-progress');
    const totalSlides = flkty.slides.length;

    // set initial progress
    updateProgress(0);

    flkty.on('change', (index) => {
      updateProgress(index);
    });

    function updateProgress(index) {
      const progress = ((index + 1) / totalSlides) * 100;
      progressBar.style.width = `${progress}%`;
    }

    return flkty;
  }
  _thumbnailSlider(){
    return(
      new Flickity(this.thumbnailSliderEle, {
        wrapAround: false,
        pageDots: false,
        draggable: window.matchMedia('(max-width: 749px)').matches,
        contain: true,
        prevNextButtons: true,
        asNavFor: this.mainSliderEle,
        cellAlign: 'left',
        resize: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      })
    );
  }
  _showImages(){
    document.querySelectorAll("media-gallery-custom-slider ul li.grid__item.slider__slide").forEach(el => {
      el.style.opacity = "1"
    })
  }
});

window.onresize = () => {
  document.querySelectorAll('media-gallery-custom-slider').forEach(ele => {
    if(ele._manSlider()) ele._manSlider().isDraggable = (window.matchMedia('(max-width: 749px)').matches);
  });

  // _manSlider();
  // _thumbnailSlider();
  // _showImages();
}

window.customPaymentIcons = function customPaymentIcons(){
  let paymentIconContainers = document.querySelectorAll('.js-payment-icons');
  paymentIconContainers.forEach(function(customPaymentWidgetWrapper) {
    let afterpaybutton = `
      <custom-payment-icon data-type="afterpay" title="ⓘ">
        <img class="compact-badge-logo" src="https://cdn.shopify.com/s/files/1/0246/5411/8978/files/afterpay_logo.png?v=1710822406" alt="afterpay" />
        <i>ⓘ</i>
      </custom-payment-icon>
    `;
    let sezzleIcon = `
      <custom-payment-icon data-type="sezzle">
        <img src="https://cdn.shopify.com/s/files/1/0246/5411/8978/files/sezzle_logo.png?v=1710822405" alt="sezzle" />
        <i>ⓘ</i>
      </custom-payment-icon>
    `;
    let shopPayIcon = `
      <custom-payment-icon data-type="shopPay">
        <img class="shop-pay-logo" src="https://cdn.shopify.com/s/files/1/0246/5411/8978/files/shoppay_logo.png?v=1710822406" alt="shopPay" />
        <i>ⓘ</i>
      </custom-payment-icon>
    `;

    if(customPaymentWidgetWrapper){
      
      let AfterpayWidget = setInterval(function () {
        if(document.querySelector('square-placement')){
          if(!customPaymentWidgetWrapper.querySelector('[data-type="afterpay"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',afterpaybutton);
          }
          clearInterval(AfterpayWidget);
        }else{
          if(!customPaymentWidgetWrapper.querySelector('[data-type="afterpay"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',afterpaybutton);
          }
          clearInterval(AfterpayWidget);
        }
      },300);
      let sezzleIconWidget = setInterval(function () {
        if(document.querySelector('.sezzle-shopify-info-button')){
          if(!customPaymentWidgetWrapper.querySelector('[data-type="sezzle"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',sezzleIcon);
          }
          clearInterval(sezzleIconWidget);
        }else{
          if(!customPaymentWidgetWrapper.querySelector('[data-type="sezzle"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',sezzleIcon);
          }
          clearInterval(sezzleIconWidget);
        }
      },300);
      let shopPayWidget = setInterval(function () {
        if(document.querySelector('shopify-payment-terms')){
          if(!customPaymentWidgetWrapper.querySelector('[data-type="shopPay"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',shopPayIcon);
          }
          clearInterval(shopPayWidget);
        }else{
          if(!customPaymentWidgetWrapper.querySelector('[data-type="shopPay"]')){
            customPaymentWidgetWrapper.insertAdjacentHTML('beforeend',shopPayIcon);
          }
          clearInterval(shopPayWidget);
        }
      },300);
    }
  });

  let AfterpayWidgetCart = setInterval(function () {
    if(document.querySelector('afterpay-placement') && document.querySelector('.template-cart')){
      let AfterHTML = document.querySelector('afterpay-placement').outerHTML;
      document.querySelector('.totals').insertAdjacentHTML('afterend', AfterHTML);
      clearInterval(AfterpayWidgetCart);
    }
  },300);

  // let buyNowText = `<div class="buy-now-text  sezzle-left szl-light" style="font-size: 14px; line-height: 18px;">Buy now, pay later with:</div>`;
  // let buyNowButtonText = document.querySelector('.buy-now-text');

  // if(!buyNowButtonText){
  //   let activeModal = document.querySelector('.quick-add-modal[open]');
  //   if(activeModal){
  //     activeModal.querySelector('.third-party-payment-options').insertAdjacentHTML('beforebegin', buyNowText);
  //   }
  // }

  customElements.define('custom-payment-icon',class customPaymentIcons extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click',function () {
        let type = this.dataset.type;
        if(type == "afterpay"){
          const afterpayModal = document.querySelector('afterpay-modal');
          if (afterpayModal) {
            const shadowRoot = afterpayModal.shadowRoot;
            if (shadowRoot) {
              const afterpayModalComponent = shadowRoot.getElementById('afterpay-modal-component');
              if (afterpayModalComponent) {
                afterpayModal.setAttribute('visible', 'visible');
                afterpayModalComponent.querySelector(".afterpay-modal-overlay").classList.add("visible")
              }
            }
          }
          // document.querySelector("square-placement").shadowRoot.querySelector('.afterpay-logo').click();
        }
        if(type == "sezzle"){
          let sezzleCheckoutButtonWrapper = document.querySelector('.sezzle-shopify-info-button .sezzle-checkout-button-wrapper');
          let sezzleInfoButton = document.querySelector('.sezzle-shopify-info-button');
          let sezzleCheckoutModalLightbox = document.querySelector('.sezzle-checkout-modal-lightbox');
          if(sezzleCheckoutButtonWrapper){
            sezzleCheckoutButtonWrapper.click();
          }else if(sezzleInfoButton){
            sezzleInfoButton.querySelector('.sezzle-checkout-button-wrapper').click();
          }else if(sezzleCheckoutModalLightbox){
            sezzleCheckoutModalLightbox.style.display = "block";
            sezzleCheckoutModalLightbox.style.maxHeight = "100%";
          }else{
            document.querySelector('.sezzle-shopify-info-button .sezzle-checkout-button-wrapper').click();
          }
          
        }
        if(type == "shopPay"){
          document.querySelector("shopify-payment-terms").shadowRoot.querySelector('#shopify-installments').querySelector('#shopify-installments-cta').click();
        }
      });
    }
  });
};
window.customPaymentIcons();


const clickBtn = document.querySelector(".all__items-cart");
const popup = document.querySelector(".popup");
const closeBtn = document.querySelector(".closeBtn");
const body = document.body;

function togglePopup() {
  popup.style.display = (popup.style.display === 'block') ? 'none' : 'block';
  body.classList.toggle('overflow-hidden', popup.style.display === 'block');
}

if (clickBtn && popup && closeBtn) {
  clickBtn.addEventListener('click', togglePopup);
  closeBtn.addEventListener('click', togglePopup);
  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      togglePopup();
    }
  });
}
/********* PDP TABS START *********/
function Tabs(options){
  var tabs = document.querySelector(options.el);
  var initCalled = false;
  if(tabs) {
    var tabNavigation = tabs.querySelector(".tabs__nav");
    var tabNavigationLinks = tabs.querySelectorAll(".tabs__nav--link");
    var tabContentContainers = tabs.querySelectorAll(".tab__wrapper");    
    var marker = options.marker ? createNavMarker() : false;
    var activeIndex = 0;
    function init(){
      if (!initCalled){
          initCalled = true;
          for (var i = 0; i < tabNavigationLinks.length; i++){
              var link = tabNavigationLinks[i];
              clickHandlerSetup(link, i)
          }
          if (marker){
              setMarker(tabNavigationLinks[activeIndex]);
          }
         tabNavigationLinks[0].classList.add('is-active');
         tabContentContainers[0].classList.add('is-active');
      }
    }
    function clickHandlerSetup(link, index){
        link.addEventListener("click", function(e){
            e.preventDefault();
            goToTab(index);
        })
    }
    function goToTab(index){
        if (index >= 0 && index != activeIndex && index <= tabNavigationLinks.length){
            tabNavigationLinks[activeIndex].classList.remove('is-active');
            tabNavigationLinks[index].classList.add('is-active');
            tabContentContainers[activeIndex].classList.remove('is-active');
            tabContentContainers[index].classList.add('is-active');
            if (marker){
                setMarker(tabNavigationLinks[index]);
            }
            activeIndex = index;
        }
    }
    function createNavMarker(){
        var marker = document.createElement("div");
        marker.classList.add("tab__nav--marker");
        tabNavigation.appendChild(marker);
        return marker;
    }
    function setMarker(element){
        marker.style.left = element.offsetLeft +"px";
        marker.style.width = element.offsetWidth + "px";
    }
    return {
        init: init,
        goToTab: goToTab
    }
  }
}
var m = new Tabs({
  el: "#product-tabs",
  marker: true
});

if(document.querySelector('#product-tabs')) {
  m.init();
}
/********* PDP TABS START *********/
$('.image-with-text-buttons').on('click', 'a', function(event) {
  var tabSection = $($(this).attr('href'));
  var tabSectionTop = tabSection.offset().top - 100;  
  $('html, body').animate({scrollTop: tabSectionTop } );
  event.preventDefault();
});

$(window).on("load resize orientationchange", function(){
  if (window.innerWidth <= 749) {
     var t = $("body").width(),
        i = 1200,
        s = t - i,
        a = s / 2;
    if(a < 20){
    var f_a = 20;
  
    } else {
    var f_a = a;      
    }
    $(".block__app").css("padding-left", f_a);
  }else {
    var t = $("body").width(),
        i = 1200,
        s = t - i,
        a = s / 2;
    if(a < 50){
    var f_a = 50;
    } else {
    var f_a = a;      
    }
    $(".block__app").css("padding-left", f_a);
  }
});
if(document.querySelector('.style__4--menu')){
  var targetElement = document.querySelector('.style__4--menu');
  var parentWithTarget = targetElement.closest('.mega-menu__list');
  if (parentWithTarget) {
    parentWithTarget.classList.add('style__4--wrapper');
  }
}
// Fetch the "/cart" page
window.fetchCartAndApplyCount = function(){
  fetch('/cart')
  .then(response => response.text())
  .then(htmlResponse => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlResponse;
    const cartTableBody = tempElement.querySelector('.cart__items tbody');
    const trCount = cartTableBody.querySelectorAll('tr').length;
    document.querySelector("sticky-header .cart-count-bubble").innerHTML = trCount;
    document.querySelector("sticky-header .cart-count-bubble").classList.remove("visually-hidden");
  })
  .catch(error => {
    console.error('Error:', error);
  });
}



function seeOffer() {
  var PopupButton = document.querySelectorAll(".PopupButton");
  var OrderSummaryPopup = document.getElementById("OrderSummaryPopup");
  var popupCloseBtn = document.getElementById("popupCloseBtn");
  if(PopupButton.length > 0 && OrderSummaryPopup != null){
  
    PopupButton.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        OrderSummaryPopup.style.display = 'block';
      });
    });
    
    popupCloseBtn.addEventListener('click', ()=>{
      OrderSummaryPopup.style.display = 'none';
    });
    OrderSummaryPopup.addEventListener('click', ()=>{
      OrderSummaryPopup.style.display = 'none';
    });
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  seeOffer();
  if(window.location.href.includes('/products')){
    function checkElement() {
        const buyNowButtonText = document.querySelector('.buy-now-text');
    }
    checkElement();
  }

  var extrasProductElem = document.querySelectorAll('.product__add--extras-wrapper');

  if(extrasProductElem.length > 0){
    function initializeExtrasFlickity() {
    let slideCount = document.querySelectorAll('.product__add--extras-wrapper .product__add--extras-product').length;
        
        window.matchHeight('.product__add--extras-product .product__add--extras-titles');

        extrasProductElem.forEach( slider => {
            var flkty = new Flickity(slider, {
              cellAlign: 'left',
              wrapAround: false,
              contain: true,
              pageDots: false,
              freeScroll: true,
              prevNextButtons: true,
              arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
              }
            });
        });
    }

    initializeExtrasFlickity();
    window.addEventListener('resize', initializeExtrasFlickity);
    

    let checkInterval = setInterval(() => {
    const flickityElem = document.querySelector('.product__add--extras-wrapper.flickity-enabled');
    
    if (flickityElem) {
        setTimeout(()=>{
          window.dispatchEvent(new Event('resize'));
        },1000)      
        clearInterval(checkInterval);
  
      }
    }, 100);
  }
  
  var freeGiftElement = document.getElementById('free_gift');
  if (freeGiftElement && freeGiftElement.getAttribute('data-checkeligibility') === 'true') {
    window.getCart();
  }
  else{
    removeFromCart();
  }

  document.querySelectorAll(`[data-index="sort-by-mobile"] .mobile-facets__label`).forEach(el => {
    el.addEventListener("click", function(e){
      e.currentTarget.closest(".js-filter.menu-opening").querySelector(".active-sort").innerText = e.currentTarget.innerText;
    })  
  })

  document.querySelectorAll(".Menu_Level_Three").forEach(el => {
    el.querySelectorAll("a").forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        const clickedHref = e.currentTarget.getAttribute("href");
        sessionStorage.setItem("lastOpenedHref", clickedHref);
      });
    });
  });
});

if(document.querySelectorAll('.kit__items--wrap-li').length > 0){
  window.kitSlider = function(){
  if(document.querySelector('.kit__items--wrap-ul')){
    let elemKit = document.querySelector('.kit__items--wrap-ul');
    let flkty = new Flickity( elemKit, {
      cellAlign: 'left',
      contain: true,
      groupCells: 2,
      pageDots: false,
      adaptiveHeight: true,
      prevNextButtons: true,
      draggable: true,
      imagesLoaded: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
     }); 
   }  
  }
  
  window.kitSlider();
}

(function () {
  kitSliderEqualHeight(false);
})();

window.onresize = function(){
  kitSliderEqualHeight(true);
}

function kitSliderEqualHeight(resize) {
  var elements = document.querySelectorAll(".kit__items--wrap--li-title"),
      allHeights = [],
      i = 0;
  if(resize === true){
    for(i = 0; i < elements.length; i++){
      elements[i].style.height = 'auto';
    }
  }
  for(i = 0; i < elements.length; i++){
    var elementHeight = elements[i].clientHeight;
    allHeights.push(elementHeight);
  }
  for(i = 0; i < elements.length; i++){
    elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
    if(resize === false){
      elements[i].className = elements[i].className + " show";
    }
  }
}

/* Cart Shipping bar -- Start */
  // const shippingBar = document.querySelector("#shipping__bar");
  // const shippingBarText = document.querySelector("#shipping__bar .shipping__text span");
  // const shippingBarProgressBar = document.querySelector("#shipping__bar progress");

  // window.updateShippingBar = function(cartData) {
  //   console.log("cartData", cartData)
  //   let newCartTotal = cartData.total_price
  //   const cartThreshold = window.cartThresholdShipping?.threshold;

  //   console.log("cartThreshold", cartThreshold)

  //   const remainingAmount = cartThreshold - newCartTotal;

  //   console.log("remainingAmount", remainingAmount)

  //   if (newCartTotal >= cartThreshold) {
  //     console.log("shippingBarText", shippingBarText)
  //     if(shippingBarText) shippingBarText.innerHTML = window.cartThresholdShipping.shippingTextAfter
  //   } else {
  //     console.log("shippingBarText else", shippingBarText)

  //     console.log("shippingBarText.innerHTML", shippingBarText.innerHTML)
  //     if(shippingBarText) shippingBarText.innerHTML = window.cartThresholdShipping?.shippingTextBefore?.replace("##REMAINING_PRICE##", `<span class="shipping__text--price">${ Shopify.formatMoney(remainingAmount, Shopify.money_format) }</span>`);
  //   }
  //   console.log("shippingBarProgressBar", shippingBarProgressBar)
  //   console.log("shippingBarProgressBar.value", shippingBarProgressBar.value)
  //   if(shippingBarProgressBar) shippingBarProgressBar.value = (newCartTotal / 100).toFixed(2);
  // }
  
  window.updateShippingBar = function(cartData) {
    const shippingBar = document.querySelector("#shipping__bar");
    const shippingBarProgressBar = document.querySelector("#shipping__bar progress");
    let newCartTotal = cartData.total_price;
    const cartThreshold = window.cartThresholdShipping?.threshold;

    if (!cartThreshold) return;

    const remainingAmount = cartThreshold - newCartTotal;
    // Re-select shippingBarText fresh each time
    const shippingBarText = document.querySelector("#shipping__bar .shipping__text span");

    if (newCartTotal >= cartThreshold) {
      if (shippingBarText) {
        shippingBarText.innerHTML = window.cartThresholdShipping.shippingTextAfter;
      }
    } else {
      if (shippingBarText) {
        const formattedRemaining = Shopify.formatMoney(remainingAmount, Shopify.money_format);
        shippingBarText.innerHTML =
          window.cartThresholdShipping?.shippingTextBefore?.replace(
            "##REMAINING_PRICE##",
            `<span class="shipping__text--price">${formattedRemaining}</span>`
          );
      }
    }

    if (shippingBarProgressBar) {
      const progressPercent = (newCartTotal / cartThreshold) * 100;
      shippingBarProgressBar.value = parseFloat(progressPercent.toFixed(2));
    }
  };


/* Cart Shipping bar -- End */


window.videoCarousel = function() {
  let isGridColumnSlider = document.querySelectorAll('.video__slider');
  isGridColumnSlider.forEach(function(elem) {
      let flkty = new Flickity(elem, {
        cellAlign: 'left',
        pageDots: false,
        groupCells: true,
        contain: true,
        prevNextButtons: true,
        arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });
  });
}
window.videoCarousel();


// craft guide slider start


function initializeCraftFlickity() {
  try {
    const extrasElem = document.querySelector('.craft__guide--slider');
    if (!extrasElem) {
      console.warn('Flickity element not found.');
      return;
    }

    const slideCount = document.querySelectorAll('.craft__guide--slider .craft__guide--item').length;
    if (slideCount === 0) {
      console.warn('No slides found.');
      return;
    }

    // Initialize Flickity with default arrows
    const flktyCraftGuide = new Flickity(extrasElem, {
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: false,
      freeScroll: false, // Disable free scroll for precise movement
      groupCells: false, // Ensure only one item slides at a time
      prevNextButtons: false, // Enable default arrows
      draggable: true, // Allow dragging if desired
    });

    // Add event listeners for custom arrows
    const prevArrow = document.querySelector('.craft__guide--product-prev');
    const nextArrow = document.querySelector('.craft__guide--product-next');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        flktyCraftGuide.previous();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        flktyCraftGuide.next();
      });
    }
    
  } catch (error) {
    console.error('Error initializing Flickity:', error);
  }
}

initializeCraftFlickity();

// Handle resize
if (!window.flickityResizeAdded) {
  window.addEventListener('resize', initializeCraftFlickity);
  window.flickityResizeAdded = true;
}

// Check Flickity initialization
let checkCraftTimeout = setTimeout(() => {
  clearInterval(checkCraftInterval);
  console.warn('Flickity initialization timed out.');
}, 5000);

let checkCraftInterval = setInterval(() => {
  const flickityElem = document.querySelector('.craft__guide--slider.flickity-enabled');
  if (flickityElem) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1000);
    clearInterval(checkCraftInterval);
    clearTimeout(checkCraftTimeout);
  }
}, 100);


// craft guide slider end

// Add Extra slider start


function upsellProductSlider() {
  try {
    const extrasElem = document.querySelector('.upsell__product--slider');
    if (!extrasElem) {
      console.warn('Flickity element not found.');
      return;
    }

    const slideCount = document.querySelectorAll('.upsell__product--slider .product__add--extras-product').length;
    if (slideCount === 0) {
      console.warn('No slides found.');
      return;
    }

    // Initialize Flickity without default arrows
    const flktyUpsell = new Flickity(extrasElem, {
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: false,
      freeScroll: false, // Disable free scroll for precise movement
      groupCells: false, // Ensure only one item slides at a time
      prevNextButtons: false, // Disable default arrows
    });

    // Add event listeners for custom arrows
    const prevArrow = document.querySelector('.upsell__product--prev');
    const nextArrow = document.querySelector('.upsell__product--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        flktyUpsell.previous();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        flktyUpsell.next();
      });
    }
  } catch (error) {
    console.error('Error initializing Flickity:', error);
  }
}

upsellProductSlider();

// Handle resize
if (!window.flickityResizeAdded) {
  window.addEventListener('resize', upsellProductSlider);
  window.flickityResizeAdded = true;
}

// Check Flickity initialization
let checkUpsellTimeout = setTimeout(() => {
  clearInterval(checkUpsellInterval);
  console.warn('Flickity initialization timed out.');
}, 5000);

let checkUpsellInterval = setInterval(() => {
  const flickityElem = document.querySelector('.upsell__product--slider.flickity-enabled');
  if (flickityElem) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1000);
    clearInterval(checkUpsellInterval);
    clearTimeout(checkUpsellTimeout);
  }
}, 100);


// Add Extra slider end


// cart drawer recomendation slider js start

function initializeFlickity() {
  
  if(document.querySelectorAll('.cart__recommendations-wrapper').length > 0){
  
  let slideCount = document.querySelectorAll('.product_add--extras-wrapper .cart__recommendations-product').length;
  var extrasElem = document.querySelector('.cart__recommendations-wrapper');
  // window.matchHeight('.cart__recommendations-product .cart__recommendations--product-title');

  var flkty = new Flickity(extrasElem, {
    cellAlign: 'left',
    wrapAround: false,
    contain: true,
    pageDots: false,
    freeScroll: true,
    prevNextButtons: true,
    adaptiveHeight: false,
    arrowShape: { 
      x0: 15,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 35
    }
  });

  // let checkInterval = setInterval(() => {
  // const flickityElem = document.querySelector('.cart__recommendations-wrapper.flickity-enabled');
  
  // if (flickityElem) {
  //     setTimeout(()=>{
  //       window.dispatchEvent(new Event('resize'));
  //     },1000)      
  //     clearInterval(checkInterval);

  //   }
  // }, 100);

  // var flktyOrderCard = new Flickity('.cart-drawer .save-every-order__cards', {
  //   cellAlign: 'left',
  //   contain: true,
  //   freeScroll: true,
  //   draggable: false,
  //   pageDots: false,
  //   prevNextButtons: false
  // });

 }
}

window.initializeFlickity;

// cart drawer recomendation slider js end

// document.addEventListener("DOMContentLoaded", function() {
//   console.log("DOMContentLoaded")
//   $('.redemDevPromo').on('click', function(event){
//     event.preventDefault();
//     var theUrl = '/checkout?discount=';
//     var theDiscount = $(this).siblings('.field__input').val();
//     var toRedirect = theUrl+theDiscount;
//     window.location.href = toRedirect;
//   });
// });


// Blog tag filtering functionality
(function() {
  const initBlogTagFilter = () => {
    const filterLinks = document.querySelectorAll('.blog-tag-filter');
    
    if (!filterLinks.length) return;
    
    filterLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const filterValue = this.getAttribute('data-filter');
        const articlesContainer = this.closest('.main-blog').querySelector('[id^="blog-articles-"]');
        const articles = articlesContainer.querySelectorAll('.blog-articles__article');
        
        // Update active state
        filterLinks.forEach(l => l.classList.remove('active'));
        this.classList.add('active');
        
        // Filter articles
        articles.forEach(article => {
          const articleTags = article.getAttribute('data-article-tags');
          
          if (filterValue === 'all') {
            // Show all articles
            article.style.display = '';
            article.style.animation = 'fadeIn 0.3s ease-in';
          } else if (articleTags && articleTags.split(',').includes(filterValue)) {
            // Show articles matching the tag
            article.style.display = '';
            article.style.animation = 'fadeIn 0.3s ease-in';
          } else {
            // Hide articles not matching the tag
            article.style.display = 'none';
          }
        });
      });
    });
  };
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogTagFilter);
  } else {
    initBlogTagFilter();
  }
})();


// window.quickOrderSlider = function () {
//   const sliders = document.querySelectorAll('.quick__order--desktop-slider, .quick__order--mobile-slider');

//   sliders.forEach((elem) => {
//     // Prevent reinitialization
//     if (elem.classList.contains('flickity-enabled')) return;

//     // Initialize Flickity
//     const flkty = new Flickity(elem, {
//       watchCSS: true,
//       cellAlign: 'left',
//       contain: true,
//       wrapAround: true,
//       groupCells: 1,
//       draggable: true,
//       freeScroll: false,
//       friction: 0.3,             // ↓ Lower = slower glide
//       selectedAttraction: 0.015,  // ↓ Lower = smoother easing
//       pageDots: false,
//       prevNextButtons: false,
//       accessibility: true,
//       dragThreshold: 5,           // slightly resist small trackpad motions
//     });

//     // Custom next/prev buttons
//     const nextButton = elem.parentElement.querySelector('.quick-slider-next');
//     const prevButton = elem.parentElement.querySelector('.quick-slider-prev');

//     if (nextButton) nextButton.addEventListener('click', () => flkty.next());
//     if (prevButton) prevButton.addEventListener('click', () => flkty.previous());

//     // ---- Trackpad horizontal scroll support ----
//     let scrollTimeout;
//     elem.addEventListener('wheel', (event) => {
//       if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
//         event.preventDefault();

//         // Debounce to avoid skipping multiple slides on one gesture
//         clearTimeout(scrollTimeout);
//         scrollTimeout = setTimeout(() => {
//           if (event.deltaX > 0) {
//             flkty.next();
//           } else if (event.deltaX < 0) {
//             flkty.previous();
//           }
//         }, 80); // delay to slow down reactions (higher = slower)
//       }
//     }, { passive: false });
//   });
// };

// document.addEventListener('DOMContentLoaded', window.quickOrderSlider);

// ATC on card media js start
window.onload = function() {
  document.querySelectorAll(".quick__order--products-item .card__media").forEach(function (cardMedia) {
    cardMedia.addEventListener("click", function (e) {
      e.preventDefault();
      
      let closestQuickOrderProductsItem = cardMedia.closest(".quick__order--products-item");
      if (!closestQuickOrderProductsItem) return;
      if (closestQuickOrderProductsItem) {
        let form = closestQuickOrderProductsItem.querySelector("form");
        if (!form) return;
        if (form) {
          let submitButton = form.querySelector("[type='submit']");
          if (!submitButton || submitButton.disabled) return;
          // Trigger the form submit event
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          
        }
      }
    });
  });
};
// ATC on card media js end
